import React, { useRef, useState } from "react";
import { ListingsByRef } from "../Components/ListingsByRef";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

export default function Hearts(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  let love = localStorage["love"].split(",").splice(1);

  const criteria = {
    hearts: [...love],
    action: "hearts",
  };
  const [state, setState] = useState({
    loved: love.length,
    dataCount: 0,
    open: false,
  });

  const [selected, setSelected] = useState(false);

  const removeOnClick = (listingID) => {
    love = love.filter((item) => item !== listingID);
    let loved = state.loved - 1;
    setTimeout(() => {
      setState({
        ...state,
        loved,
        dataCount: state.dataCount - 1,
      });
    }, 1000);
  };

  const s = (count) => {
    if (count > 1) return "s";
    return "";
  };
  const haveHas = (count) => {
    if (count > 1) return "have";
    return "has";
  };

  const openClearConfirmation = () => {
    setState({ ...state, open: true });
  };
  const closeClearConfirmation = () => {
    setState({ ...state, open: false });
  };

  const ReportCount = (dataCount = 0) => {
    setState({ ...state, dataCount });
  };

  const confirmClear = () => {
    localStorage["love"] = "";
    localStorage.removeItem("linkedHomes");
    localStorage.removeItem("linkedAgents");
    window.location.reload();
    localStorage["love"] = "";
  };
  return (
    <>
      <div className="center" style={{ margin: "1rem 0" }}>
        {!state.loved || (
          <Typography variant="body1" color="initial" display={"block"}>
            {`You have found ${state.loved} home${s(state.loved)} you love!`}
          </Typography>
        )}
        {state.dataCount === state.loved || (
          <Typography variant="body1" color="initial" display={"block"}>
            {`Since your last visit however, ${state.loved - state.dataCount} home${s(state.loved - state.dataCount)} ${haveHas(
              state.loved - state.dataCount
            )} become
            unavailable and are no longer being displayed.`}
          </Typography>
        )}
        {!state.loved || (
          <>
            <Button variant="outlined" color="secondary" onClick={openClearConfirmation}>
              CLEAR ALL
            </Button>
            <Dialog
              fullScreen={fullScreen}
              open={state.open}
              onClose={closeClearConfirmation}
              aria-labelledby="responsive-dialog-title">
              <DialogTitle id="responsive-dialog-title">{"Are you sure?"}</DialogTitle>
              <DialogContent>
                <DialogContentText>This action will clear all the homes where your heart might be.</DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button autoFocus onClick={closeClearConfirmation} color="primary">
                  No
                </Button>
                <Button onClick={confirmClear} color="primary" autoFocus>
                  I'm sure
                </Button>
              </DialogActions>
            </Dialog>
          </>
        )}
        {!state.loved && (
          <>
            <Typography variant="body1" color="initial">
              It's where the heart would be.
            </Typography>
            <Typography variant="body1" color="initial">
              <a href={`${process.env.PUBLIC_URL}/`}>Click here</a> to find more homes where your heart might be.
            </Typography>
          </>
        )}
      </div>

      <ListingsByRef
        display={"loved"}
        criteria={criteria}
        makeLove={props.makeLove}
        removeOnClick={removeOnClick}
        reportCount={ReportCount}
        setSelected={setSelected}
        selected={selected}
      />
    </>
  );
}
